<template>
  <v-dialog v-model="dialog" persistent width="1000px" scrollable>
    <card>
      <card-title
        large
        closeable
        class="flex-grow-0"
        @click:close="dialog = false"
      >
        Сводка изменений (ID: {{ itemId }})
      </card-title>

      <card-content>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="items"
          class="v-datatable-stripped"
          :page.sync="page"
        >
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template #item.action_name="{ item }">
            {{ actionNames[item.action_name] || item.action_name }}
          </template>
        </v-data-table>
      </card-content>
    </card>
  </v-dialog>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import Repository from "@/api/history";
import Const from "@/utils/Const.js";

export default {
  mixins: [NotificationMixin],
  model: {
    prop: "open",
    event: "changeDialog"
  },
  props: {
    /**
     * v-model параметр.
     * Используется в dialog
     */
    open: {
      type: Boolean,
      default: false
    },
    /**
     * ID записи по которой нужна история
     */
    itemId: {
      type: [Number, String],
      default: null
    },
    /**
     * Название страницы
     */
    actionPage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      items: [],
      page: 1,
      loading: false
    };
  },
  computed: {
    actionNames() {
      return Const.ActionNames;
    },
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("changeDialog", value);
      }
    },
    headers() {
      return [
        {
          text: "ID",
          value: "id",
          sortable: false
        },
        {
          text: "Дата",
          value: "dt",
          sortable: false
        },
        {
          text: "Пользователь",
          value: "user_name",
          sortable: false
        },
        {
          text: "Действие",
          value: "action_name",
          sortable: false
        },
        {
          text: "IP",
          value: "ip",
          sortable: false
        }
      ];
    }
  },
  watch: {
    open(newV) {
      if (newV && this.userId !== 0) {
        this.loadHistory();
      }
      if (!newV) {
        this.resetForm();
        this.$emit("close");
      }
    }
  },
  methods: {
    async loadHistory() {
      try {
        const { itemId, actionPage } = this;
        this.loading = true;
        const { data } = await Repository.getObjectHistory(actionPage, itemId);
        const { items } = data;
        this.items = items;
      } catch (error) {
        this.sendError(error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.dialog = false;
      this.items = [];
      this.page = 1;
    }
  }
};
</script>
